import React from 'react';
import { useRegion, REGIONS } from '@/context/RegionContext';
import { ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

// Seletor compacto para header
export const RegionSelector = ({ variant = 'default', className = '' }) => {
  const { region, setRegion, config } = useRegion();
  
  if (variant === 'minimal') {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className={`flex items-center gap-1 text-sm hover:opacity-80 ${className}`}>
            <span className="text-xl">{config.flag}</span>
            <ChevronDown className="w-3 h-3" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {Object.values(REGIONS).map((r) => (
            <DropdownMenuItem
              key={r.code}
              onClick={() => setRegion(r.code)}
              className={region === r.code ? 'bg-orange-50' : ''}
            >
              <span className="text-xl mr-2">{r.flag}</span>
              <span>{r.name}</span>
              <span className="ml-2 text-gray-400 text-xs">{r.currency.symbol}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className={`gap-2 ${className}`}>
          <span className="text-lg">{config.flag}</span>
          <span className="hidden sm:inline">{config.name}</span>
          <ChevronDown className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {Object.values(REGIONS).map((r) => (
          <DropdownMenuItem
            key={r.code}
            onClick={() => setRegion(r.code)}
            className={`flex items-center justify-between ${region === r.code ? 'bg-orange-50' : ''}`}
          >
            <div className="flex items-center gap-2">
              <span className="text-xl">{r.flag}</span>
              <span>{r.name}</span>
            </div>
            <span className="text-gray-400">{r.currency.symbol}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

// Seletor grande para landing page
export const RegionSelectorLarge = ({ className = '' }) => {
  const { region, setRegion } = useRegion();
  
  return (
    <div className={`flex gap-3 ${className}`}>
      {Object.values(REGIONS).map((r) => (
        <button
          key={r.code}
          onClick={() => setRegion(r.code)}
          className={`flex items-center gap-2 px-4 py-2 rounded-xl border-2 transition-all ${
            region === r.code
              ? 'border-orange-500 bg-orange-50 shadow-sm'
              : 'border-gray-200 hover:border-gray-300 bg-white'
          }`}
        >
          <span className="text-2xl">{r.flag}</span>
          <div className="text-left">
            <p className={`font-medium ${region === r.code ? 'text-orange-600' : 'text-gray-900'}`}>
              {r.name}
            </p>
            <p className="text-xs text-gray-500">{r.currency.symbol} • {r.document.name}</p>
          </div>
        </button>
      ))}
    </div>
  );
};

export default RegionSelector;
